//local imports
import { Messenger } from "@app/shared";
import { ToastLevel, ToastMessage } from "@app/components";
import {
  CatalogStateService,
  ProgramModel,
  RefreshFilterMessage,
} from "@app/catalog";

import {
  ProgramAddedMessage,
  ProgramUpdatedMessage,
  ProgramCreatedNotification,
  ProgramUpdatedNotification,
} from "@app/catalog-common";

export class ProgramStateHandler {
  public initialize(
    catalogStateService: CatalogStateService,
    messenger: Messenger,
  ) {
    //TODO:DIW:Moving message handling for entities into SRP classes
    messenger.subscribe(
      catalogStateService,
      ProgramCreatedNotification,
      (message: ProgramCreatedNotification) => {
        let newProgram = new ProgramModel();

        newProgram.id = message.programId;

        newProgram.name.set(message.programName);

        this.updateProgram(newProgram, message);

        catalogStateService.CatalogManagementState.programs.set([
          newProgram,
          ...catalogStateService.CatalogManagementState.programs(),
        ]);

        messenger.send(
          ToastMessage.create(
            new ProgramAddedMessage(newProgram),
            ToastLevel.Information,
          ),
        );
        messenger.send(new RefreshFilterMessage());
      },
    );

    messenger.subscribe(
      catalogStateService,
      ProgramUpdatedNotification,
      (message: ProgramUpdatedNotification) => {
        let program =
          catalogStateService.CatalogManagementState.programs().find(
            (u) => u.id === message.programId,
          );

        if (!program) {
          program = new ProgramModel();
          program.id = message.programId;

          program.name.set(message.programName);
        }

        this.updateProgram(program, message);

        messenger.send(new RefreshFilterMessage());
        messenger.send(
          ToastMessage.create(
            new ProgramUpdatedMessage(program),
            ToastLevel.Information,
          ),
        );
      },
    );
  }

  private updateProgram(
    program: ProgramModel,
    message: ProgramCreatedNotification | ProgramUpdatedNotification,
  ) {
    //TODO:DIW:Move into it's own class..
    //TODO:DIW:Set properties by reading changed properties collection and mapping..

    for (let change of message.changes) {
      if (change.propertyName.toLowerCase() === "name") {
        program.name.set(change.newValue);
      }
    }
  }
}
